import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./navbar.css";

export default function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");

  const handleLogout = () => {
    // 🔹 Limpia datos de sesión
    localStorage.removeItem("access_token");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userId");

    // 🔹 Redirige al login
    navigate("/login");
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <span>🎲 Bingo Online - Administrador</span>
        </div>
        <div className="navbar-links">
          <Link
            to="/gestion"
            className={`nav-link ${
              location.pathname === "/gestion" ? "active" : ""
            }`}
          >
            📋 Gestión del Bingo
          </Link>
          <Link
            to="/sorteo"
            className={`nav-link ${
              location.pathname === "/sorteo" ? "active" : ""
            }`}
          >
            🎯 Tiradas del Sorteo
          </Link>
          {/* <Link
            to="/pagos"
            className={`nav-link ${
              location.pathname === "/pagos" ? "active" : ""
            }`}
          >
            💳 Pagos
          </Link> */}

          {token ? (
            <button
              onClick={handleLogout}
              className={`nav-link ${
                location.pathname === "/login" ? "active" : ""
              }`}
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              🚪 Logout
            </button>
          ) : (
            <Link
              to="/login"
              className={`nav-link ${
                location.pathname === "/login" ? "active" : ""
              }`}
            >
              🔑 Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
